import { Box, TextField } from "@mui/material";
import { InvoiceItemDto } from "../../../models/dto/CreateInvoiceDto";
import { useEffect, useState } from "react";

type AddInvoiceItemProps = {
  invoiceItems?: InvoiceItemDto[];
  newInvoiceItem: InvoiceItemDto;
  editMode?: boolean;
  onChange: (
    id: string,
    value: string | number,
    editedInvoiceItem?: InvoiceItemDto
  ) => void;
};

export const AddInvoiceItem = ({
  invoiceItems,
  newInvoiceItem,
  editMode = false,
  onChange,
}: AddInvoiceItemProps) => {
  const [inputValue, setInputValue] = useState(newInvoiceItem.unitprice);
  const evaluateExpression = (exp: string) => {
    try {
      if (!/^[0-9+\-*/().\s]+$/.test(exp)) return NaN;

      return Function(`"use strict"; return (${exp})`)();
    } catch {
      return NaN;
    }
  };

  const nextPosition =
  (invoiceItems ?? []).reduce(
    (max, item) => Math.max(max, Number(item.position) || 0),
    0
  ) + 1;

  useEffect(() => {
  !editMode && onChange("position", nextPosition);
}, [nextPosition]);

  return (
    <>
      <Box className="position">
        <TextField
          variant="outlined"
          InputProps={{ disableUnderline: true }}
          value={newInvoiceItem ? newInvoiceItem.position : nextPosition}
          disabled
        />
      </Box>
      <Box className="description">
        <TextField
          fullWidth
          variant="outlined"
          value={newInvoiceItem.description}
          onChange={(e) => onChange("description", e.target.value)}
          InputProps={{ disableUnderline: true }}
        />
      </Box>
      <Box className="unitPrice">
        <TextField
          variant="outlined"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={(e) =>
            onChange("unitprice", evaluateExpression(e.target.value))
          }
        />
      </Box>
      <Box className="amount">
        <TextField
          variant="outlined"
          onChange={(e) => onChange("amount", e.target.value)}
          InputProps={{ disableUnderline: true }}
          value={newInvoiceItem.amount}
        />
      </Box>
      <Box className="unit">
        <TextField
          variant="outlined"
          onChange={(e) => onChange("unit", e.target.value)}
          InputProps={{ disableUnderline: true }}
          value={newInvoiceItem.unit}
        />
      </Box>
      <Box className="totalBefore">
        <TextField
          variant="outlined"
          disabled
          InputProps={{ disableUnderline: true }}
          value={newInvoiceItem.priceBefore}
        />
      </Box>
      <Box className="vat">
        <TextField
          variant="outlined"
          onChange={(e) => onChange("vat", e.target.value)}
          InputProps={{ disableUnderline: true }}
          value={newInvoiceItem.vat}
        />
      </Box>
      <Box className="total">
        <TextField
          variant="outlined"
          disabled
          InputProps={{ disableUnderline: true }}
          value={newInvoiceItem.priceTotal}
        />
      </Box>
    </>
  );
};
